import React from 'react';
import ShowcaseReel from './ShowcaseReel';

// PROVE IT PAGE
export const proveItContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    { id: 'intro-card', blocks: [{ type: 'custom', render: () => <ShowcaseReel slug="prove-it" card="https://proveit.so" alt="Prove It" /> }] },
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Web & Mobile App
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Prove It', size: 'h1' },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A side hustle income tracker that lets you log your weekly earnings, visualize your growth over time, and generate shareable proof cards to show your progress. Works on web, iOS, and Android.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
              <a
                href="https://proveit.so"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
              >
                Visit Live Site
              </a>
              <a
                href="https://apps.apple.com/app/id6757345722"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', display: 'inline-flex' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 40" style={{ height: '40px' }}>
                  <rect width="120" height="40" rx="6" fill="black" />
                  <rect x="0.5" y="0.5" width="119" height="39" rx="5.5" stroke="white" strokeOpacity="0.25" fill="none" />
                  <text x="38" y="12" fill="white" fontSize="7" fontFamily="-apple-system, system-ui, sans-serif" letterSpacing="0.02em">Download on the</text>
                  <text x="38" y="27" fill="white" fontSize="14" fontWeight="600" fontFamily="-apple-system, system-ui, sans-serif" letterSpacing="-0.01em">App Store</text>
                  <g transform="translate(10, 6) scale(0.6)">
                    <path d="M24.769 20.3a5.98 5.98 0 0 1 2.849-5.016 6.124 6.124 0 0 0-4.828-2.611c-2.04-.214-4.015 1.217-5.052 1.217-1.054 0-2.651-1.2-4.37-1.163a6.4 6.4 0 0 0-5.394 3.29c-2.326 4.03-.592 9.96 1.637 13.22 1.115 1.594 2.42 3.376 4.137 3.313 1.676-.068 2.304-1.07 4.329-1.07 2.011 0 2.597 1.07 4.348 1.03 1.798-.03 2.925-1.605 3.998-3.216a13.248 13.248 0 0 0 1.824-3.718 5.778 5.778 0 0 1-3.478-5.276zM21.508 10.383a5.892 5.892 0 0 0 1.348-4.225 5.995 5.995 0 0 0-3.88 2.008 5.612 5.612 0 0 0-1.382 4.065 4.96 4.96 0 0 0 3.914-1.848z" fill="white"/>
                  </g>
                </svg>
              </a>
              <span style={{
                background: 'var(--bg-accent)',
                color: 'var(--text-accent)',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600'
              }}>
                Live
              </span>
            </div>
          )
        }
      ]
    },
    { id: 'showcase-motion', blocks: [{ type: 'custom', render: () => <ShowcaseReel slug="prove-it" video alt="Prove It" /> }] },
    { id: 'showcase-live-demo', blocks: [{ type: 'custom', render: () => <ShowcaseReel slug="prove-it" frames={[1, 2]} alt="Prove It" /> }] },

    // LIVE EMBED
    {
      id: 'live-demo',
      title: 'Try Prove It Live',
      blocks: [
        {
          type: 'text',
          content: 'Log your weekly side hustle income, track your streaks, and see your growth chart update in real time.',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '80vh',
              minHeight: '600px',
              background: '#000',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              border: '2px solid var(--border-color)'
            }}>
              <iframe
                src="https://proveit.so"
                title="Prove It Live"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </div>
          )
        }
      ]
    },

    // APP SCREENSHOTS
    {
      id: 'screenshots',
      title: 'Inside the app',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const screens = [
              { src: '/portfolio-screens/proveit/1.png', label: 'Tracking Mode' },
              { src: '/portfolio-screens/proveit/2.png', label: 'Enter Amount' },
              { src: '/portfolio-screens/proveit/3.png', label: 'Income History' },
              { src: '/portfolio-screens/proveit/4.png', label: 'Growth Chart' },
              { src: '/portfolio-screens/proveit/5.png', label: 'Input Currency' },
              { src: '/portfolio-screens/proveit/6.png', label: 'Display Currency' },
              { src: '/portfolio-screens/proveit/7.png', label: 'Share Cards' }
            ];
            return (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '16px',
                maxWidth: '500px',
                margin: '0 auto'
              }}>
                {screens.map((screen, i) => (
                  <div key={i} style={{ textAlign: 'center' }}>
                    <img
                      src={screen.src}
                      alt={screen.label}
                      style={{
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid var(--border-color)',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)'
                      }}
                    />
                    <p style={{
                      color: 'var(--text-secondary)',
                      fontSize: '0.75rem',
                      marginTop: '8px'
                    }}>
                      {screen.label}
                    </p>
                  </div>
                ))}
              </div>
            );
          }
        }
      ]
    },
    { id: 'showcase-features', blocks: [{ type: 'custom', render: () => <ShowcaseReel slug="prove-it" frames={[3, 4]} alt="Prove It" /> }] },

    // FEATURES
    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const features = [
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
                  </svg>
                ),
                title: 'Weekly Income Logging',
                desc: 'Log your side hustle earnings each week and track how much you\'re pulling in over time'
              },
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                  </svg>
                ),
                title: 'Growth Chart',
                desc: 'Interactive line chart showing your income trend over the last 12 weeks'
              },
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
                  </svg>
                ),
                title: 'Stats Dashboard',
                desc: 'Total earned, growth %, current streak, best week, worst week, and weekly average — all at a glance'
              },
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                  </svg>
                ),
                title: 'Shareable Proof Cards',
                desc: 'Generate cards with your stats to share on social media'
              },
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
                  </svg>
                ),
                title: 'Multi-Currency',
                desc: 'Earn in one currency, view in another — supports USD, EUR, GBP, SAR, and AED'
              },
              {
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
                  </svg>
                ),
                title: 'Cross-Platform',
                desc: 'Works on web, iOS, and Android — built with Capacitor for native mobile support'
              }
            ];
            return (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '24px'
              }}>
                {features.map((feature, i) => (
                  <div key={i} style={{
                    background: 'var(--bg-secondary)',
                    padding: '24px',
                    borderRadius: '16px',
                    border: '1px solid var(--border-color)'
                  }}>
                    <div style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, rgba(0, 198, 255, 0.12) 0%, rgba(0, 114, 255, 0.12) 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '16px',
                      color: '#0072ff'
                    }}>
                      {feature.icon}
                    </div>
                    <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0, lineHeight: '1.5' }}>{feature.desc}</p>
                  </div>
                ))}
              </div>
            );
          }
        }
      ]
    },
    { id: 'showcase-tech', blocks: [{ type: 'custom', render: () => <ShowcaseReel slug="prove-it" frames={[5]} alt="Prove It" /> }] },

    // TECH STACK
    {
      id: 'tech',
      title: 'Tech Stack',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '16px'
            }}>
              {[
                { category: 'Frontend', items: ['React 19', 'Vite', 'Tailwind CSS', 'Framer Motion'] },
                { category: 'Data & Auth', items: ['Supabase (PostgreSQL)', 'Email + Google Auth', 'localStorage (guest mode)'] },
                { category: 'Visualization', items: ['Recharts', 'html-to-image', 'Lucide React'] },
                { category: 'Mobile', items: ['Capacitor', 'iOS + Android', 'Native Share API'] }
              ].map((group, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-color)',
                  borderRadius: '12px',
                  padding: '20px'
                }}>
                  <h4 style={{
                    color: 'var(--text-accent)',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    marginBottom: '12px'
                  }}>
                    {group.category}
                  </h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {group.items.map((item, j) => (
                      <span key={j} style={{
                        color: 'var(--text-secondary)',
                        fontSize: '0.9rem'
                      }}>
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    // HOW IT WAS BUILT
    {
      id: 'process',
      title: 'How It Was Built',
      blocks: [
        {
          type: 'container',
          background: true,
          blocks: [
            {
              type: 'text',
              content: 'Prove It started as a simple idea — a way to track side hustle income week by week and actually see whether you\'re growing or not. Guest mode stores everything in localStorage so you can use it without signing up. If you create an account, Supabase syncs your data across devices. Capacitor wraps the web app into native iOS and Android builds.',
              size: 'normal',
              align: 'left'
            },
            { type: 'spacer', size: 'small' },
            {
              type: 'custom',
              render: () => (
                <ul style={{
                  color: 'var(--text-secondary)',
                  fontSize: '0.95rem',
                  lineHeight: '1.6',
                  paddingLeft: '20px',
                  margin: 0
                }}>
                  <li>Recharts for the interactive 12-week growth line chart</li>
                  <li>html-to-image to generate shareable proof cards as images</li>
                  <li>Supabase handles auth, database, and real-time sync</li>
                  <li>Capacitor builds native apps from the same React codebase</li>
                  <li>date-fns for week calculations and date formatting</li>
                  <li>Framer Motion for smooth page transitions</li>
                </ul>
              )
            }
          ]
        }
      ]
    }
  ],

  callToAction: {
    endCard: '/showcase/prove-it/end.webp',
    brand: { bg: "#080808", fg: "#FFFFFF", btnBg: "#FFFFFF", btnFg: "#080808" },
    title: 'Prove It',
    button: { text: 'Try Prove It →', url: 'https://proveit.so' }
  }
};